
// Defaults per handoff doc 2.3 — overridable per-article via bottomCta* fields.
const DEFAULTS = {
  headline: "Ready to Find Your Sauna?",
  body: "The right outdoor sauna depends on your space, your style, and how you want to use it.",
  primaryLabel: "Explore Our Collection",
  primaryUrl: "https://leisurecraft.com/all-saunas",
  secondaryLabel: "Find a Dealer Near You",
  secondaryUrl: "https://leisurecraft.com/retailer",
};

export default {
  name: "BottomCta",
  props: {
    cta: { type: Object, default: () => ({}) },
  },
  computed: {
    headline() {
      return this.cta.headline || DEFAULTS.headline;
    },
    body() {
      return this.cta.body || DEFAULTS.body;
    },
    primaryLabel() {
      return this.cta.primaryLabel || DEFAULTS.primaryLabel;
    },
    primaryUrl() {
      return this.cta.primaryUrl || DEFAULTS.primaryUrl;
    },
    secondaryLabel() {
      return this.cta.secondaryLabel || DEFAULTS.secondaryLabel;
    },
    secondaryUrl() {
      return this.cta.secondaryUrl || DEFAULTS.secondaryUrl;
    },
  },
};
